module.exports = __webpack_public_path__ + "static/img/c8mBg.f5513858.png";